import { render } from "./CaseDetailPublic.vue?vue&type=template&id=ed7f06a2&scoped=true"
import script from "./CaseDetailPublic.vue?vue&type=script&lang=js"
export * from "./CaseDetailPublic.vue?vue&type=script&lang=js"

import "./CaseDetailPublic.vue?vue&type=style&index=0&id=ed7f06a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7f06a2"]])

export default __exports__